import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/lib/i18n";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Projekte from "@/pages/Projekte";
import ProjektDetail from "@/pages/ProjektDetail";
import ProjektNeu from "@/pages/ProjektNeu";
import Kunden from "@/pages/Kunden";
import KundeDetail from "@/pages/KundeDetail";
import DesignerPool from "@/pages/DesignerPool";
import DesignerProfil from "@/pages/DesignerProfil";
import Verwaltung from "@/pages/Verwaltung";
import InviteAccept from "@/pages/InviteAccept";
import MeinProfil from "@/pages/MeinProfil";
import KundenFreigabe from "@/pages/KundenFreigabe";
import "@/index.css";

function Protected({ children, allow }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center bg-paper mono-label">Laden…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (allow && !allow.includes(user.rolle)) return <Navigate to="/" replace />;
  return children;
}

function GuestOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
            <Route path="/invite/:token" element={<InviteAccept />} />
            <Route path="/kundenfreigabe/:token" element={<KundenFreigabe />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="projekte" element={<Projekte />} />
              <Route path="projekte/neu" element={<Protected allow={["admin", "pm"]}><ProjektNeu /></Protected>} />
              <Route path="projekte/:id" element={<ProjektDetail />} />
              <Route path="kunden" element={<Protected allow={["admin", "pm"]}><Kunden /></Protected>} />
              <Route path="kunden/:id" element={<Protected allow={["admin", "pm"]}><KundeDetail /></Protected>} />
              <Route path="designer" element={<Protected allow={["admin", "pm"]}><DesignerPool /></Protected>} />
              <Route path="verwaltung" element={<Protected allow={["admin"]}><Verwaltung /></Protected>} />
              <Route path="mein-profil" element={<Protected allow={["admin", "pm"]}><MeinProfil /></Protected>} />
              <Route path="profil" element={<Protected allow={["designer"]}><DesignerProfil /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </LangProvider>
    </AuthProvider>
  );
}

export default App;
